export const version: string = "0.1.0";
export default version;
